<ion-header>
  <ion-toolbar color="primary" no-border-bottom>
    <!-- <ion-buttons slot="start">
      <ion-button (click)="showPrivacy()">
        {{ 'fpm.button.privacy' | translate }}
      </ion-button>
    </ion-buttons> -->
    <ion-title>{{ 'APP.TITLE.About' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content padding>
  <ion-grid>
    <ion-row>
      <ion-col class="text-center">
        <div class="about-header">
          <img src="assets/images/logo/logo.png" alt="ONAM" width="120">
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="text-justify ion-padding">
        <div class="about-info" [innerHTML]="'APP.ABOUT.CompanyDescription' | translate "></div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="text-center">
        <p>
          <ion-text color="primary" (click)="gotoSite('https://www.onam.it')">www.onam.it</ion-text>
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="text-center">
        <ion-button color="light" (click)="showPrivacy()">{{ 'APP.TITLE.PrivacyPolicy' | translate
          }}</ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer class="about-footer">
  <ion-toolbar color="ligth">
    <ion-buttons slot="start">
      <ion-button class="text-small" size="small" (click)="showPrivacy()">{{ 'APP.TITLE.PrivacyPolicy' | translate
        }}</ion-button>
      <!-- <p class="developed-by">{{ 'fpm.about.developed-by' | translate }}</p> -->
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button class="text-small" size="small" (click)="showCredits()">{{ 'APP.TITLE.Credits' | translate
        }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
